// extracted by mini-css-extract-plugin
export var inputContainer = "_sl-0";